import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const AuthorDashboardIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3820_26382)">
      <path
        d="M13.2917 50.75C11.6893 50.75 10.1526 50.1135 9.01956 48.9804C7.88653 47.8474 7.25 46.3107 7.25 44.7083V3.625C7.25 2.66359 6.86808 1.74156 6.18826 1.06174C5.50844 0.381919 4.58641 0 3.625 0C2.66359 0 1.74156 0.381919 1.06174 1.06174C0.381919 1.74156 0 2.66359 0 3.625L0 44.7083C0 48.2335 1.40037 51.6143 3.89304 54.107C6.38571 56.5996 9.7665 58 13.2917 58H54.375C55.3364 58 56.2584 57.6181 56.9383 56.9383C57.6181 56.2584 58 55.3364 58 54.375C58 53.4136 57.6181 52.4916 56.9383 51.8117C56.2584 51.1319 55.3364 50.75 54.375 50.75H13.2917Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M47.125 43.5C48.0864 43.5 49.0084 43.1181 49.6883 42.4383C50.3681 41.7584 50.75 40.8364 50.75 39.875V25.375C50.75 24.4136 50.3681 23.4916 49.6883 22.8117C49.0084 22.1319 48.0864 21.75 47.125 21.75C46.1636 21.75 45.2416 22.1319 44.5617 22.8117C43.8819 23.4916 43.5 24.4136 43.5 25.375V39.875C43.5 40.8364 43.8819 41.7584 44.5617 42.4383C45.2416 43.1181 46.1636 43.5 47.125 43.5Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M18.125 43.5C19.0864 43.5 20.0084 43.1181 20.6883 42.4383C21.3681 41.7584 21.75 40.8364 21.75 39.875V25.375C21.75 24.4136 21.3681 23.4916 20.6883 22.8117C20.0084 22.1319 19.0864 21.75 18.125 21.75C17.1636 21.75 16.2416 22.1319 15.5617 22.8117C14.8819 23.4916 14.5 24.4136 14.5 25.375V39.875C14.5 40.8364 14.8819 41.7584 15.5617 42.4383C16.2416 43.1181 17.1636 43.5 18.125 43.5Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M32.625 43.5001C33.5864 43.5001 34.5084 43.1182 35.1883 42.4383C35.8681 41.7585 36.25 40.8365 36.25 39.8751V13.2917C36.25 12.3303 35.8681 11.4083 35.1883 10.7285C34.5084 10.0487 33.5864 9.66675 32.625 9.66675C31.6636 9.66675 30.7416 10.0487 30.0617 10.7285C29.3819 11.4083 29 12.3303 29 13.2917V39.8751C29 40.8365 29.3819 41.7585 30.0617 42.4383C30.7416 43.1182 31.6636 43.5001 32.625 43.5001Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
    </g>
    <defs>
      <clipPath id="clip0_3820_26382">
        <rect width="58" height="58" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
